/**
 * T975 — a pageview held while the SDK downloads must describe the page it was captured on.
 * The SDK computes `title` and `$prev_pageview_pathname` when it sends, so the Provider
 * keeps the originals under these keys and `before_send` puts them back (and drops the keys).
 * Lightweight on purpose: the Provider imports it without pulling the SDK into its graph.
 */
export const HELD_TITLE = "$tfc_held_title";
export const HELD_PREV_PATHNAME = "$tfc_held_prev_pathname";

type EventLike = { properties?: Record<string, unknown> } | null | undefined;

export function restoreHeldPageContext<E extends EventLike>(event: E): E {
  const properties = event?.properties;
  if (!properties) return event;
  if (HELD_TITLE in properties) {
    properties.title = properties[HELD_TITLE];
    delete properties[HELD_TITLE];
  }
  if (HELD_PREV_PATHNAME in properties) {
    properties.$prev_pageview_pathname = properties[HELD_PREV_PATHNAME];
    delete properties[HELD_PREV_PATHNAME];
  }
  return event;
}
